let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4qL5x")).then(() => parcelRequire('jjqbH'));